var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',_vm._b({staticClass:"language-switcher--modal-item",attrs:{"href":_vm.url}},'a',_vm.$attrs,false),[(_vm.isActive)?_c('span',{staticClass:"language-switcher--active"}):_vm._e(),_c('span',{staticClass:"language-switcher--modal-text",attrs:{"dir":"ltr"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }